import React from 'react';
import {
    TableChart,
    FeaturedPlayList,
    Today,
    Description,
    PointOfSale,
    Subject,
    Warehouse,
    MenuBook,
    MarkAsUnread,
    Logout,
    ImportContacts,
    QrCode,
    Home,
    Groups
} from '@mui/icons-material';
import AppSidebar, { SidebarSection } from '../../layout/AppSidebar';
import usePermissions from '../../../utils/usePermissions';

interface DashboardSidebarProps {
    selectedIndex: number;
    onMenuItemClick: (index: number) => void;
    onLogout: () => void;
    onOpenService: (url: string) => void;
    isInterfaceBlocked: boolean;
}

const MAIL_PAGE_INDEX = 11;

/**
 * Боковое меню кабинета аптеки (/dashboard) на общем компоненте AppSidebar.
 * Каждый пункт открывается правом матрицы /dashboard (PBAC): пункт раздела требует и `<модуль>.menu`.
 * Профиль пользователя находится в шапке (AppHeader).
 */
const DashboardSidebar: React.FC<DashboardSidebarProps> = ({
    selectedIndex,
    onMenuItemClick,
    onLogout,
    onOpenService,
    isInterfaceBlocked
}) => {
    const { hasPerm } = usePermissions();

    const sections: SidebarSection[] = [
        {
            key: 'home',
            items: [{ key: 'home', label: 'Главная', icon: <Home />, index: 20, perms: ['home.menu'] }]
        },
        {
            key: 'reports',
            title: 'Отчетность',
            items: [
                { key: 'current', label: 'Текущий отчет', icon: <TableChart />, index: 0, perms: ['reports.menu', 'reports.current.view'] },
                { key: 'month', label: 'Отчет за месяц', icon: <FeaturedPlayList />, index: 1, perms: ['reports.menu', 'reports.monthly.view'] }
            ]
        },
        {
            key: 'documents',
            title: 'Документы',
            items: [
                { key: 'invoices', label: 'Документооборот', icon: <Description />, index: 7, perms: ['documents.menu', 'documents.flow.view'] },
                { key: 'marking', label: 'КМ\'ы', icon: <QrCode />, index: 12, perms: ['documents.menu', 'documents.marking.view'] },
                { key: 'tabel', label: 'Табель РБ', icon: <Today />, index: 3, perms: ['timesheet.menu'] },
                { key: 'journal', label: 'Электронный журнал', icon: <ImportContacts />, index: 10, perms: ['journal.menu'] }
            ]
        },
        {
            key: 'monitoring',
            title: 'Мониторинг',
            items: [
                { key: 'cash', label: 'Касса', icon: <PointOfSale />, index: 4, perms: ['monitoring.menu', 'monitoring.cash.view'] },
                { key: 'km', label: 'КМ', icon: <Subject />, index: 5, perms: ['monitoring.menu', 'monitoring.km.view'] }
            ]
        },
        {
            key: 'guide',
            title: 'Справочник',
            items: [
                { key: 'remains', label: 'Остатки', icon: <Warehouse />, index: 6, perms: ['guide.remains.menu'] },
                { key: 'nomenclature', label: 'Номенклатура', icon: <MenuBook />, index: 9, perms: ['guide.nomenclature.menu'] }
            ]
        },
        {
            key: 'point',
            title: 'Точка',
            items: [{ key: 'staff', label: 'Сотрудники', icon: <Groups />, index: 13, perms: ['staff.menu'] }]
        }
    ];

    return (
        <AppSidebar
            id="dashboard"
            sections={sections}
            hasPerm={hasPerm}
            selectedIndex={selectedIndex}
            onSelect={(index) => onMenuItemClick(index)}
            disabled={isInterfaceBlocked}
            footerActions={[
                {
                    key: 'mail',
                    label: 'Почта',
                    icon: <MarkAsUnread />,
                    iconOnly: true,
                    selected: selectedIndex === MAIL_PAGE_INDEX,
                    onClick: () => { if (!isInterfaceBlocked) onMenuItemClick(MAIL_PAGE_INDEX); }
                },
                {
                    key: 'guide',
                    label: 'База знаний',
                    icon: <MenuBook />,
                    iconOnly: true,
                    onClick: () => onOpenService('https://guide.zerdegroup.kz/')
                },
                { key: 'logout', label: 'Выйти', icon: <Logout />, onClick: onLogout, danger: true }
            ]}
        />
    );
};

export default DashboardSidebar;
